<svg width="70" height="37" viewBox="0 0 70 37" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_1016_4000)">
<path d="M46.5327 22.3003L51.5727 17.3138L35.0002 0.91748L18.4277 17.3138L23.4677 22.3003H46.5327Z" fill="#280D0A"/>
<path d="M44.8172 23.9912H0.810547V36.0533H69.1889V23.9912H44.8172ZM34.9997 33.7044L26.8914 25.6822H43.1081L34.9997 33.7044Z" fill="#280D0A"/>
</g>
<defs>
<clipPath id="clip0_1016_4000">
<rect width="70" height="37" fill="white"/>
</clipPath>
</defs>
</svg>
